import { TrendingUp } from 'lucide-react';
import { formatNumber, formatCurrencyTiny, formatCurrencyCompact } from '../../utils/bundleFormatters';

export default function PriceSection({ initialPrice, finalPrice, priceIncrease }) {
  // Visualise the initial vs final price bars — heights scale by log so
  // even huge multipliers stay readable in the tiny column.
  const barHeight = (v) => {
    if (!Number.isFinite(v) || v <= 0) return 8;
    return Math.max(12, Math.min(140, Math.log10(v + 1) * 55));
  };

  return (
    <div className="rounded-xl border border-border bg-card p-4 sm:p-6 shadow-sm">
      <h3 className="text-sm sm:text-base font-semibold mb-4 flex items-center" data-testid="bundle-price-title">
        <TrendingUp className="mr-2 w-4 h-4 text-emerald-500" />
        Price Impact
      </h3>

      <div className="relative h-40 mb-6 mt-2">
        <div className="absolute bottom-0 left-1/4 -translate-x-1/2 flex flex-col items-center">
          <div className="w-8 rounded-t bg-blue-500/70" style={{ height: `${barHeight(initialPrice * 1e9)}px` }} />
          <span className="text-[10px] text-muted-foreground mt-2">Initial</span>
        </div>
        <div className="absolute bottom-0 right-1/4 translate-x-1/2 flex flex-col items-center">
          <div className="w-10 rounded-t bg-emerald-500/80" style={{ height: `${barHeight(finalPrice * 1e9)}px` }} />
          <span className="text-[10px] text-muted-foreground mt-2">Final</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 mt-6">
        <div className="p-3 rounded-lg bg-muted/40 border border-border">
          <div className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1">Initial Price</div>
          <div className="text-sm font-bold font-mono" data-testid="bundle-initial-price">{formatCurrencyTiny(initialPrice)}</div>
        </div>
        <div className="p-3 rounded-lg bg-muted/40 border border-border">
          <div className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1">Final Price</div>
          <div className="text-sm font-bold font-mono text-emerald-500" data-testid="bundle-final-price">{formatCurrencyCompact(finalPrice)}</div>
        </div>
      </div>

      <div className="mt-4 p-3 rounded-lg bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-between">
        <span className="text-sm">Price Increase</span>
        <span className="text-base font-bold text-emerald-500 flex items-center font-mono" data-testid="bundle-price-multiplier">
          {formatNumber(priceIncrease, 2)}×
          <TrendingUp className="ml-1 w-4 h-4" />
        </span>
      </div>
    </div>
  );
}
